export const NATIVE_TOKEN = 'nativeToken';
export const IMPERSONATE_TOKEN = 'impersonateToken';
